import React from 'react';

import { useMediaQuery } from 'react-responsive';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { ApiObject, Country } from 'app/types';

import Text from 'common/components/Text/Text';

import styles from './Tabs.module.scss';

interface CompProps {
  country?: ApiObject<Country>;
}

const Details = ({ country }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={styles.overviewContainer}>
      {country?.data?.tags?.[0] && (
        <div className={styles.section}>
          <div className={styles.tagsContainer}>
            {country?.data.tags.map((tag) => (
              <div className={styles.tag} key={tag.id}>
                <div className={styles.icon}>
                  <i className="bi bi-bookmark"></i>
                </div>
                <div>
                  <Text size={isMobile ? 14 : 16} weight={600}>
                    {tag.name}
                  </Text>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {country?.data.about && (
        <div className={styles.section}>
          <Text size={isMobile ? 15 : 20} weight={700}>
            About
          </Text>
          <div className={styles.paragraph}>
            <Text color="primary" size={isMobile ? 14 : 16} inlineStyle={{ textAlign: 'justify' }}>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>{country.data.about}</ReactMarkdown>
            </Text>
          </div>
        </div>
      )}
      {country?.data.why_choose_this_country && (
        <div className={styles.section}>
          <Text size={isMobile ? 15 : 20} weight={700}>
            Why choose this country?
          </Text>
          <div className={styles.paragraph}>
            <Text color="primary" size={isMobile ? 14 : 16} inlineStyle={{ textAlign: 'justify' }}>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {country.data.why_choose_this_country}
              </ReactMarkdown>
            </Text>
          </div>
        </div>
      )}
      {country?.data.popular_cities?.length && (
        <div className={styles.section}>
          <Text size={isMobile ? 15 : 20} weight={700}>
            Popular cities
          </Text>
          <div className="accordion" id="accordionPanelsStayOpenExample">
            {country.data.popular_cities.map((city, index) =>
              city.study_life ? (
                <div className={`accordion-item ${styles.accordionItem}`} key={city.id}>
                  <div className="accordion-header" id="panelsStayOpen-headingTwo">
                    <button
                      className={`accordion-button ${styles.button} collapsed`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#panelsStayOpen-collapse${index}`}
                      aria-expanded="true"
                      aria-controls={`panelsStayOpen-collapse${index}`}
                    >
                      <p>{city.name}</p>
                    </button>
                    <hr />
                  </div>
                  <div
                    id={`panelsStayOpen-collapse${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`panelsStayOpen-collapse${index}`}
                  >
                    <div className="accordion-body">
                      <Text
                        color="secondary"
                        size={isMobile ? 14 : 16}
                        inlineStyle={{ textAlign: 'justify' }}
                      >
                        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{city.study_life}</ReactMarkdown>
                      </Text>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.cityRow} key={city.id}>
                  <div>
                    <Text size={isMobile ? 14 : 16} weight={isMobile ? 500 : 700} color="secondary">
                      {city.name}
                    </Text>
                  </div>
                  <hr />
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Details;
